var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "bp-box is-info" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("main", [
        _vm.editMode || !_vm.request.airline
          ? _c(
              "div",
              { staticClass: "is-one-row" },
              [
                _c("i", { staticClass: "material-icons" }, [
                  _vm._v("business"),
                ]),
                _vm._v(" Airline:\n                "),
                _c("airline-select", {
                  staticClass: "has-margin-left",
                  attrs: {
                    placeholderInfo: {
                      startAirport: _vm.request.startAirport,
                      endAirport: _vm.request.endAirport,
                    },
                    "show-airport-selects": false,
                  },
                  on: {
                    updateStartAirport: (value) =>
                      (_vm.request.startAirport = value),
                    updateEndAirport: (value) =>
                      (_vm.request.endAirport = value),
                  },
                  model: {
                    value: _vm.request.airline,
                    callback: function ($$v) {
                      _vm.$set(_vm.request, "airline", $$v)
                    },
                    expression: "request.airline",
                  },
                }),
                _vm._v(" "),
                _c("agency-select", {
                  staticClass: "has-margin-left",
                  attrs: {
                    value: _vm.request.agency,
                    provider: null,
                    prefill: "",
                    text: "Agentur",
                  },
                  on: { update: (agency) => (_vm.request.agency = agency) },
                }),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "is-one-row" }, [
          _c("div", { staticClass: "is-300" }, [
            _c("i", { staticClass: "material-icons" }, [
              _vm._v("import_contacts"),
            ]),
            _vm._v(" Status:\n                    "),
            _c("div", { staticClass: "select has-margin-right" }, [
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.request.requestStatus.status,
                      expression: "request.requestStatus.status",
                    },
                  ],
                  on: {
                    change: function ($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function (o) {
                          return o.selected
                        })
                        .map(function (o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.$set(
                        _vm.request.requestStatus,
                        "status",
                        $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      )
                    },
                  },
                },
                [
                  _vm._l(_vm.requestStatuses, function (status) {
                    return [
                      _c("option", { domProps: { value: status.key } }, [
                        _vm._v(_vm._s(status.value)),
                      ]),
                    ]
                  }),
                ],
                2
              ),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "is-300" },
            [
              _c("i", { staticClass: "material-icons" }, [
                _vm._v("notifications_none"),
              ]),
              _vm._v(" Termine:\n                    "),
              _vm.request.todos.length > 1
                ? _c("multiselect", {
                    staticClass: "is-shorter",
                    attrs: {
                      options: _vm.request.todos,
                      label: "name",
                      "track-by": "id",
                    },
                    model: {
                      value: _vm.request.optionTodo,
                      callback: function ($$v) {
                        _vm.$set(_vm.request, "optionTodo", $$v)
                      },
                      expression: "request.optionTodo",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("datepicker", {
                staticClass: "has-margin-right",
                attrs: {
                  inputClass: ["is-date"],
                  config: {
                    dateFormat: "d.m.Y H:i:S",
                    wrap: true,
                    parseDate: function (dateStr) {
                      return _vm.moment(dateStr, "DD.MM.YYYY hh:mm:ss").toDate()
                    },
                    formatDate: function (dateObj) {
                      return _vm.moment(dateObj).format("DD.MM.YYYY hh:mm:ss")
                    },
                    allowInput: true,
                    altInput: true,
                  },
                  placeholder: "Deadline",
                },
                model: {
                  value: _vm.deadline,
                  callback: function ($$v) {
                    _vm.deadline = $$v
                  },
                  expression: "deadline",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", [
            _c("i", { staticClass: "material-icons" }, [
              _vm._v("image_aspect_ratio"),
            ]),
            _vm._v(" Flugnummer\n                    "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.request.flightNumber,
                  expression: "request.flightNumber",
                },
              ],
              staticClass: "input has-margin-right",
              attrs: { type: "text" },
              domProps: { value: _vm.request.flightNumber },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.request, "flightNumber", $event.target.value)
                },
              },
            }),
          ]),
          _vm._v(" "),
          _c("div", [
            _c("i", { staticClass: "material-icons" }, [
              _vm._v("image_aspect_ratio"),
            ]),
            _vm._v(" PNR\n                    "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.request.ticketNr,
                  expression: "request.ticketNr",
                },
              ],
              staticClass: "input has-margin-right",
              attrs: { type: "text" },
              domProps: { value: _vm.request.ticketNr },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.request, "ticketNr", $event.target.value)
                },
              },
            }),
          ]),
          _vm._v(" "),
          _c("div", [
            _c("i", { staticClass: "material-icons" }, [
              _vm._v("local_dining"),
            ]),
            _vm._v(" Verpflegung\n                    "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.request.foodOnBoard,
                  expression: "request.foodOnBoard",
                },
              ],
              staticClass: "input has-margin-right",
              attrs: { type: "text" },
              domProps: { value: _vm.request.foodOnBoard },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.request, "foodOnBoard", $event.target.value)
                },
              },
            }),
          ]),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("i", { staticClass: "material-icons" }, [
                _vm._v("contact_phone"),
              ]),
              _vm._v(" Ansprechpartner:\n                    "),
              _c("multiselect", {
                staticClass: "is-shorter",
                staticStyle: { "min-width": "180px" },
                attrs: {
                  options: this.request.agency
                    ? this.agencyContactOptions
                    : this.providerContactOptions,
                  "track-by": "id",
                  "custom-label": (contact) => `${contact.fullName}`,
                  "to-be-copied": false,
                },
                model: {
                  value: _vm.request.requestContact,
                  callback: function ($$v) {
                    _vm.$set(_vm.request, "requestContact", $$v)
                  },
                  expression: "request.requestContact",
                },
              }),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _vm.showAssignedContactAddress
          ? _c("div", { staticClass: "is-last-row" }, [
              _c("div", [
                _c("i", { staticClass: "material-icons" }, [_vm._v("list")]),
                _vm._v(" Für Kunde sichtbar:\n                    "),
                _c(
                  "button",
                  {
                    staticClass: "button is-icon-button",
                    class: {
                      "is-active":
                        _vm.request.visibleContactDetails.includes("address"),
                    },
                    attrs: { title: "Adresse anzeigen" },
                    on: {
                      click: function ($event) {
                        return _vm.setVisibleContactDetails("address")
                      },
                    },
                  },
                  [_c("i", { staticClass: "material-icons" }, [_vm._v("home")])]
                ),
              ]),
              _vm._v(" "),
              _vm.request.visibleContactDetails.includes("address")
                ? _c(
                    "div",
                    [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("home"),
                      ]),
                      _vm._v(" Adresse\n                    "),
                      _c("multiselect", {
                        staticClass: "is-shorter",
                        staticStyle: { "min-width": "150px" },
                        attrs: {
                          options: _vm.providerAddressOptions,
                          "track-by": "id",
                          "custom-label": (address) =>
                            (address.title
                              ? address.title + ": " + address.streetAddress
                              : address.streetAddress
                            ).substring(0, 50),
                          "to-be-copied": false,
                          placeholder: "Keine Adresse",
                        },
                        model: {
                          value: _vm.request.assignedAddress,
                          callback: function ($$v) {
                            _vm.$set(_vm.request, "assignedAddress", $$v)
                          },
                          expression: "request.assignedAddress",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.request.visibleContactDetails.includes("address")
                ? _c("div", [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("list"),
                    ]),
                    _vm._v(" Kontaktdetails sichtbar:\n                    "),
                    _c(
                      "button",
                      {
                        staticClass: "button is-icon-button",
                        class: {
                          "is-active":
                            _vm.request.visibleContactDetails.includes(
                              "phoneFixed"
                            ),
                        },
                        attrs: { title: "Festnetz anzeigen" },
                        on: {
                          click: function ($event) {
                            return _vm.setVisibleContactDetails("phoneFixed")
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("phone"),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "button is-icon-button",
                        class: {
                          "is-active":
                            _vm.request.visibleContactDetails.includes(
                              "phoneMobile"
                            ),
                        },
                        attrs: { title: "Mobile anzeigen" },
                        on: {
                          click: function ($event) {
                            return _vm.setVisibleContactDetails("phoneMobile")
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("smartphone"),
                        ]),
                      ]
                    ),
                  ])
                : _vm._e(),
            ])
          : _vm._e(),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "columns" }, [
      _c("div", { staticClass: "column" }, [
        _c("div", { staticClass: "bp-box is-tickets" }, [
          _c("header", [
            _vm._m(1),
            _vm._v(" "),
            _vm._m(2),
            _vm._v(" "),
            _c("div", [
              !_vm.request.package
                ? _c(
                    "button",
                    {
                      attrs: { title: "Extraticket für Reisebegleitung" },
                      on: { click: _vm.addExtra },
                    },
                    [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("person_add"),
                      ]),
                    ]
                  )
                : _vm._e(),
            ]),
          ]),
          _vm._v(" "),
          _c("main", [
            _c("div", [
              _vm._m(3),
              _vm._v(" "),
              _c("div", [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model.number",
                      value: _vm.request.contingent.reservedAmount,
                      expression: "request.contingent.reservedAmount",
                      modifiers: { number: true },
                    },
                  ],
                  staticClass: "input",
                  attrs: { type: "text" },
                  domProps: { value: _vm.request.contingent.reservedAmount },
                  on: {
                    focus: function ($event) {
                      return $event.target.select()
                    },
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(
                        _vm.request.contingent,
                        "reservedAmount",
                        _vm._n($event.target.value)
                      )
                    },
                    blur: function ($event) {
                      return _vm.$forceUpdate()
                    },
                  },
                }),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model.number",
                      value: _vm.request.contingent.askedAmount,
                      expression: "request.contingent.askedAmount",
                      modifiers: { number: true },
                    },
                  ],
                  staticClass: "input",
                  attrs: { type: "text" },
                  domProps: { value: _vm.request.contingent.askedAmount },
                  on: {
                    focus: function ($event) {
                      return $event.target.select()
                    },
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(
                        _vm.request.contingent,
                        "askedAmount",
                        _vm._n($event.target.value)
                      )
                    },
                    blur: function ($event) {
                      return _vm.$forceUpdate()
                    },
                  },
                }),
              ]),
              _vm._v(" "),
              _c("div", [
                _c(
                  "button",
                  {
                    staticClass: "button",
                    attrs: { title: "Copy value" },
                    on: {
                      click: function ($event) {
                        _vm.request.contingent.reservedAmount =
                          _vm.request.contingent.askedAmount
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("check_circle"),
                    ]),
                    _vm._v(" "),
                    _c("i", {
                      staticClass: "fa fa-long-arrow-left",
                      attrs: { "aria-hidden": "true" },
                    }),
                    _vm._v(" "),
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("help"),
                    ]),
                  ]
                ),
              ]),
            ]),
            _vm._v(" "),
            _vm.hasExtra && !_vm.request.package
              ? _c("div", { staticClass: "extra-people" }, [
                  _c("div", [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("person_add"),
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.request.contingent.extraDescription,
                          expression: "request.contingent.extraDescription",
                        },
                      ],
                      staticClass: "input",
                      attrs: { type: "text" },
                      domProps: {
                        value: _vm.request.contingent.extraDescription,
                      },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.request.contingent,
                            "extraDescription",
                            $event.target.value
                          )
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn-delete",
                        attrs: { title: "Löschen", tabindex: "-1" },
                        on: { click: _vm.deleteExtra },
                      },
                      [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("delete"),
                        ]),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c("div", { staticClass: "control" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.number",
                            value: _vm.request.contingent.extraReservedAmount,
                            expression:
                              "request.contingent.extraReservedAmount",
                            modifiers: { number: true },
                          },
                        ],
                        staticClass: "input",
                        attrs: { type: "text" },
                        domProps: {
                          value: _vm.request.contingent.extraReservedAmount,
                        },
                        on: {
                          focus: function ($event) {
                            return $event.target.select()
                          },
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.request.contingent,
                              "extraReservedAmount",
                              _vm._n($event.target.value)
                            )
                          },
                          blur: function ($event) {
                            return _vm.$forceUpdate()
                          },
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "control" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.number",
                            value: _vm.request.contingent.extraAskedAmount,
                            expression: "request.contingent.extraAskedAmount",
                            modifiers: { number: true },
                          },
                        ],
                        staticClass: "input",
                        attrs: { type: "text" },
                        domProps: {
                          value: _vm.request.contingent.extraAskedAmount,
                        },
                        on: {
                          focus: function ($event) {
                            return $event.target.select()
                          },
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.request.contingent,
                              "extraAskedAmount",
                              _vm._n($event.target.value)
                            )
                          },
                          blur: function ($event) {
                            return _vm.$forceUpdate()
                          },
                        },
                      }),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c(
                      "button",
                      {
                        staticClass: "button",
                        attrs: { title: "Copy value" },
                        on: {
                          click: function ($event) {
                            _vm.request.contingent.extraReservedAmount =
                              _vm.request.contingent.extraAskedAmount
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("check_circle"),
                        ]),
                        _vm._v(" "),
                        _c("i", {
                          staticClass: "fa fa-long-arrow-left",
                          attrs: { "aria-hidden": "true" },
                        }),
                        _vm._v(" "),
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("help"),
                        ]),
                      ]
                    ),
                  ]),
                ])
              : _vm._e(),
          ]),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "columns" }, [
      _c(
        "div",
        { staticClass: "column is-one-third" },
        [
          _c("tip-tap", {
            model: {
              value: _vm.request.notes,
              callback: function ($$v) {
                _vm.$set(_vm.request, "notes", $$v)
              },
              expression: "request.notes",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "column" },
        [
          _vm.request.package && _vm.request.package.itemPrices
            ? _c("item-prices", {
                attrs: {
                  isWithoutPrice: false,
                  "is-package": true,
                  provider: _vm.provider,
                },
                model: {
                  value: _vm.request.package.itemPrices,
                  callback: function ($$v) {
                    _vm.$set(_vm.request.package, "itemPrices", $$v)
                  },
                  expression: "request.package.itemPrices",
                },
              })
            : _c("item-prices", {
                attrs: { isWithoutPrice: false, provider: _vm.provider },
                model: {
                  value: _vm.request.itemPrices,
                  callback: function ($$v) {
                    _vm.$set(_vm.request, "itemPrices", $$v)
                  },
                  expression: "request.itemPrices",
                },
              }),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _vm._m(4),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("header", [
      _c("i", { staticClass: "material-icons" }, [_vm._v("info")]),
      _vm._v(" Informationen zur Anfrage"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("i", { staticClass: "material-icons", attrs: { title: "Tickets" } }, [
        _vm._v("airplanemode_active"),
      ]),
      _vm._v(" Airline"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("i", { staticClass: "material-icons" }, [_vm._v("check_circle")]),
      _vm._v(" "),
      _c("i", { staticClass: "material-icons" }, [_vm._v("help")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("i", { staticClass: "material-icons", attrs: { title: "Tickets" } }, [
        _vm._v("airplanemode_active"),
      ]),
      _vm._v(" Tickets"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "explanation" }, [
      _c("i", { staticClass: "material-icons" }, [_vm._v("check_circle")]),
      _vm._v(" = bestätigtes Kontingent\n        "),
      _c("i", { staticClass: "material-icons" }, [_vm._v("help")]),
      _vm._v(" = angefragtes Kontingent\n        "),
      _c("i", { staticClass: "material-icons" }, [_vm._v("person_add")]),
      _vm._v(" = Extrazimmer für Busfahrer, Reiseleiter, etc.\n    "),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }